import React from "react";
import { connect } from "react-redux";


// import moment from "moment";
import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png'
import './pushRequestLogResult.css'
import LeftArrowImg from '../../../assets/images/left-arrow.png'
import RightArrowImg from '../../../assets/images/right-arrow.png'


export class PushRequestLogResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1

        }

    }


    getSmtpLogData = () => {

        let sortedArray = this.props.pushRequestLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage)
        let JSX = [];

        sortedArray.forEach((entry) => {
            JSX.push(<tr className="PushRequestLogResult-value" key={entry.id}>
                <td className="PushRequestLogResult-date-value">{entry.insertedon.split('.')[0].replace('T', ' ')}</td>

                <td className="PushRequestLogResult-method-value">{entry.scheduledid}</td>

                <td className="PushRequestLogResult-endpoint-value">{entry.campaignid}</td>

                <td> {entry.decision === 'a' ? "Approved" : entry.decision=== 'r' ? "Rejected" : "Pending" } </td>

                <td className="PushRequestLogResult-date-value">{ entry.decisiontime ? entry.decisiontime.split('.')[0].replace('T', ' ') : "NA"}</td>

                {/* <td className="PushRequestLogResult-responsecode-value">{entry.URL}</td> */}
            </tr>)
        })

        return JSX;

    }

    moveNextPage = () =>{
        if(this.state.currentPage < this.props.maxPage ){
            this.setState({currentPage: this.state.currentPage+1})
        }
    }
    movePreviousPage = () =>{
        if(this.state.currentPage > 1){
            this.setState({currentPage:this.state.currentPage - 1})
        }
    }

    conditionalRendering = () => {
        if (this.props.pushRequestLogs) {
            return (<div className="PushRequestLogResult">

                <div className="PushRequestLogResult-log-details-container">
                    <table className="PushRequestLogResult-log-details">
                        <thead>
                            <tr>
                                <th className="PushRequestLogResult-date">Requested On</th>
                                <th className="PushRequestLogResult-method">ScheduleId</th>
                                <th className="PushRequestLogResult-input">CampaignId</th>
                                <th className="PushRequestLogResult-endpoint">Decision</th>
                                <th className="PushRequestLogResult-date">Action On</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getSmtpLogData(this.state.currentPage)}
                        </tbody>
                    </table>
                </div>
                <div className="PushRequestLogResult-pagination">
                    <div className="PushRequestLogResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>

                    <div className="PushRequestLogResult-pagination-buttongroup">
                        <button className="PushRequestLogResult-pagination-button-previous" onClick={this.movePreviousPage}>
                            <img src={LeftArrowImg} alt="Previous" ></img>
                        </button>
                        <button className="PushRequestLogResult-pagination-button-next" onClick={this.moveNextPage}>
                            <img src={RightArrowImg} alt="Next" ></img>
                        </button>
                    </div>
                </div>

            </div>)
        } else {
            return (<div className="CampaignResult-default">
                <img src={campaignResultDefaultImg} alt="Default" />
                <div> Let The Search Begin!</div>
            </div>)
        }
    }



    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    if (state.logs.smtpPushLogs.logs && state.logs.smtpPushLogs.logs.length) {
        //showing 25 entries max per page
        return {pushRequestLogs: state.logs.smtpPushLogs.logs, maxPage: state.logs.smtpPushLogs.logs.length % 25 === 0 ? state.logs.smtpPushLogs.logs.length / 25 : Math.ceil(state.logs.smtpPushLogs.logs.length / 25) };
    }else{
        return{pushRequestLogs: null, maxPage: 1}
    }
};

export default connect(mapStateToProps)(PushRequestLogResult);
